<template>
  <div class="payment-error container py-5">
    <div class="card shadow-sm">
      <div class="card-body text-center py-5">
        <div class="error-icon mb-4">
          <i class="fas fa-times-circle text-danger fa-5x"></i>
        </div>
        <h1 class="card-title">Pembayaran Gagal</h1>
        <p class="card-text mb-4">Mohon maaf, pembayaran Anda tidak dapat diproses saat ini. Berikut detail error yang mungkin dapat membantu:</p>
        
        <div class="error-details alert alert-danger mb-4">
          {{ errorMessage || 'Terjadi kesalahan saat memproses pembayaran Anda. Silakan coba lagi atau gunakan metode pembayaran lain.' }}
        </div>
        
        <div class="troubleshooting mb-4">
          <h5>Langkah yang dapat dilakukan:</h5>
          <ul class="list-group list-group-flush text-start">
            <li class="list-group-item bg-transparent">Periksa koneksi internet Anda</li>
            <li class="list-group-item bg-transparent">Pastikan kartu kredit/debit Anda aktif untuk transaksi online</li>
            <li class="list-group-item bg-transparent">Periksa saldo/limit kartu Anda</li>
            <li class="list-group-item bg-transparent">Coba metode pembayaran lainnya</li>
          </ul>
        </div>

        <div class="mt-4">
          <router-link to="/langganan" class="btn btn-primary me-3">Coba Lagi</router-link>
          <router-link to="/help-center" class="btn btn-outline-primary">Bantuan</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentError',
  data() {
    return {
      errorMessage: null
    };
  },
  mounted() {
    // Try to extract error message from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    this.errorMessage = urlParams.get('message') || null;
    
    // Track payment error event
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'payment_error', {
        'event_category': 'payment',
        'event_label': this.errorMessage || 'Unknown error'
      });
    }
  }
};
</script>

<style scoped>
.payment-error {
  max-width: 768px;
  margin: 0 auto;
}

.error-icon {
  color: #dc3545;
}

.card {
  border-radius: 10px;
  border: none;
}

.list-group-item {
  padding: 0.75rem 1.25rem;
}

.alert {
  border-radius: 8px;
}
</style>